import PuzzleService from '_services/rest/modules/puzzle';
import { handleResourceLoadError } from '_utils';

export default {
  state: {
    puzzleWalls: null,
    hasChanges: false,
  },
  mutations: {
    setPuzzleWalls(state, puzzleWalls) {
      state.puzzleWalls = puzzleWalls;
    },
    setHasChanges(state, status) {
      state.hasChanges = status;
    },
  },
  actions: {
    setPuzzleWalls({ commit }, model) {
      commit('setPuzzleWalls', model);
    },
    setHasChanges({ commit }, status) {
      commit('setHasChanges', status);
    },
    getPuzzleWalls({ commit, dispatch }, id) {
      return PuzzleService.getPuzzleById(id)
        .then(response => {
          commit('setPuzzleWalls', response);
          commit('setHasChanges', false);
        })
        .catch(error => {
          handleResourceLoadError(dispatch, error, 'admin-puzzle-walls-list');
        });
    },
  },
};
